import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import BasicButton from '../../../../components/BasicButton';
import FirmSection from '../../../../components/FirmSection';
import List from '../../../List';
import FirmPortfolioItem from '../FirmPortfolioItem';

const FirmPortfolioFirms = props => {
  const {
    user,
    isEditMode,
    title,
    type,
    grid: { rows = [], page = 0, rowsCount = 0, perPage = 0 },
    onClickAdd,
    onClickEdit,
    onClickDelete,
    onClickDealButton,
    onClickPage,
    onAddComment,
    onRemovePortfolioComment,
    onClickShowPreviousComments,
  } = props;

  const containerEl = useRef(null);

  const handleChangePage = page => {
    if (containerEl.current) {
      containerEl.current.scrollIntoView({
        block: 'start',
        inline: 'nearest',
      });
    }

    onClickPage({ type, page });
  };

  return (
    (rows.length > 0 || isEditMode) && (
      <FirmSection
        frameless={true}
        header={
          <div className="firm-portfolio__items-head" ref={containerEl}>
            <span
              className="firm-portfolio__items-icon"
              aria-label="Portfolio Items"
              role="img"
            />
            <h2 className="firm-portfolio__items-title">{title}</h2>
            {isEditMode && (
              <div className="firm-portfolio__items-control">
                <BasicButton
                  controlFunc={onClickAdd}
                  btnWidth={100}
                  btnHeight={35}
                  btnFontWeight={500}
                  btnArrow={false}
                  btnBg="#fff"
                  btnTextColor="#27282d"
                  btnText="Add Firm"
                />
              </div>
            )}
          </div>
        }
      >
        {rows.length > 0 && (
          <List
            scrollToTop={false}
            items={rows}
            pagination={{
              page,
              perPage,
              count: rowsCount,
            }}
            actions={{ onChangePage: handleChangePage }}
            itemRender={item => (
              <FirmPortfolioItem
                user={user}
                record={item}
                key={item.PortfolioID}
                editMode={isEditMode}
                onClickEdit={onClickEdit}
                onClickDelete={onClickDelete}
                onClickDealButton={onClickDealButton}
                onAddComment={onAddComment}
                onRemoveComment={onRemovePortfolioComment}
                onClickShowPreviousComments={onClickShowPreviousComments}
              />
            )}
          />
        )}
      </FirmSection>
    )
  );
};

FirmPortfolioFirms.propTypes = {
  user: PropTypes.object.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['Current', 'Realized']).isRequired,
  grid: PropTypes.shape({
    rows: PropTypes.array.isRequired,
    page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rowsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pagesCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    perPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onClickAdd: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickDealButton: PropTypes.func,
  onClickPage: PropTypes.func.isRequired,
};

export default FirmPortfolioFirms;
